<div
  class="idea-bar"
  [ngClass]="{ unpublished: !idea.published }"
  (click)="ideaClick()">
  <div class="image">
    <img alt [src]="thumbnailImage" />
  </div>
  <div class="texts">
    <div>
      <div class="topic" *ngIf="showTopic">
        <a routerLink="/topics/{{ session._id }}">
          {{ session.config.title }}
        </a>
      </div>
      <div class="title">{{ idea.title }}</div>
      <div class="one-liner">{{ idea.one_liner }}</div>
    </div>
  </div>
  <div class="status d-xs-none d-md-block">
    <ng-container *ngIf="idea.moves && idea.moves.length > 0">
      Moved
    </ng-container>
    <ng-container *ngIf="!idea.published">Draft</ng-container>
  </div>
  <div class="author d-xs-none d-md-block">
    <!-- {{ createdBy }} -->
    <name-tag [user]="createdBy" [link]="true" [showOrg]="false"></name-tag>
  </div>
  <div class="dates d-xs-none d-md-block">
    {{ creationDate }}
  </div>
  <div class="actions">
    <p class="comments d-xs-none d-md-block">
      <i class="icon-chat"></i>
      {{ num(idea.comments.length) }}
    </p>
    <p class="collaborators d-xs-none d-md-block">
      <i class="icon-people"></i>
      {{ num(idea.collaborators.length + 1) }}
    </p>
    <p class="followers">
      <i
        (click)="iFollow ? unfollow($event) : follow($event)"
        [ngClass]="iFollow ? 'icon-star-full' : 'icon-star-empty'"></i>
      {{ num(idea.followers.length) }}
    </p>
  </div>
</div>
